/* ============================================================
   NAV GOOEY — port a vanilla del GooeyNav de Rare UI
   (rareui.com/components/gooeynav → components/ui/gooey-nav.tsx)
   Los segmentos se separan con un muelle y, mientras la costura se
   abre, un cuello líquido (SVG con degradado) une el trozo activo con
   sus vecinos. Sin framer-motion: muelle integrado a mano con rAF.
   ============================================================ */
(function () {
  var nav = document.querySelector('nav[data-gooey]');
  if (!nav) return;
  var lista = nav.querySelector('.g-list');
  if (!lista) return;
  var segs = [].slice.call(lista.querySelectorAll('.g-seg'));
  if (segs.length < 2) return;

  var links = segs.map(function (s) { return s.querySelector('a'); });
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mq = window.matchMedia('(min-width: 641px)');
  var activo = mq.matches;

  var cs = getComputedStyle(nav);
  var SPAN = parseFloat(cs.getPropertyValue('--g-span')) || 11;
  var RAD = parseFloat(cs.getPropertyValue('--g-radius')) || 11;
  var C_BAR = (cs.getPropertyValue('--g-bar') || '#e8e3d6').trim();
  var C_ACT = (cs.getPropertyValue('--g-act') || '#0b0d10').trim();
  var NECK_H = 100;
  var NECK_BREAK = 0.5;   // 0,22 en el original: el cuello moria antes de verse

  /* ---------- muelle (stiffness 200, damping 28, mass 1) ---------- */
  function Muelle(v) { this.x = v; this.v = 0; this.t = v; }
  Muelle.prototype.set = function (t) { this.t = t; };
  Muelle.prototype.jump = function (t) { this.x = t; this.t = t; this.v = 0; };
  Muelle.prototype.step = function (dt) {
    var f = -200 * (this.x - this.t) - 28 * this.v;
    this.v += f * dt;
    this.x += this.v * dt;
  };
  Muelle.prototype.reposo = function () {
    return Math.abs(this.x - this.t) < 0.02 && Math.abs(this.v) < 0.05;
  };

  var gaps = segs.map(function () { return new Muelle(0); });
  var objetivo = 0, real = 0;

  /* ---------- indice activo segun la URL ---------- */
  var path = (location.pathname.replace(/\/+$/, '') || '/');
  var mejor = -1, mejorLen = 0;
  links.forEach(function (a, i) {
    var h = (a.getAttribute('href') || '').replace(/^https?:\/\/[^\/]+/, '').replace(/\/+$/, '');
    if (!h || h === '/') return;
    if (path === h || path.indexOf(h + '/') === 0) {
      if (h.length > mejorLen) { mejorLen = h.length; mejor = i; }
    }
  });
  if (mejor < 0 && /^\/(products|collections)\//.test(path)) {
    links.forEach(function (a, i) {
      if ((a.getAttribute('href') || '').indexOf('/collections') > -1 && mejor < 0) mejor = i;
    });
  }
  real = mejor > -1 ? mejor : 0;

  /* ---------- cuellos (uno por costura) ---------- */
  var necks = segs.map(function (seg, i) {
    if (i === 0) return null;
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'g-neck');
    svg.setAttribute('width', SPAN);
    svg.setAttribute('viewBox', '0 0 ' + SPAN + ' ' + NECK_H);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    var defs = document.createElementNS(ns, 'defs');
    var gid = 'gneck-' + i;
    var grad = document.createElementNS(ns, 'linearGradient');
    grad.setAttribute('id', gid);
    grad.setAttribute('x1', '0'); grad.setAttribute('x2', '1');
    var s1 = document.createElementNS(ns, 'stop'); s1.setAttribute('offset', '0');
    var s2 = document.createElementNS(ns, 'stop'); s2.setAttribute('offset', '1');
    grad.appendChild(s1); grad.appendChild(s2); defs.appendChild(grad);
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', '');
    p.setAttribute('fill', 'url(#' + gid + ')');
    svg.appendChild(defs); svg.appendChild(p);
    seg.appendChild(svg);
    return { svg: svg, path: p, s1: s1, s2: s2 };
  });

  /* ---------- pintado ---------- */
  function pinta() {
    var shift = 0;
    for (var i = 0; i < segs.length; i++) {
      shift += gaps[i].x;
      var izq = i === 0 ? RAD : RAD * Math.max(0, Math.min(1, gaps[i].x / SPAN));
      var der = (i + 1 < segs.length) ? RAD * Math.max(0, Math.min(1, gaps[i + 1].x / SPAN)) : RAD;
      segs[i].style.transform = Math.abs(shift) > 0.01 ? 'translateX(' + shift.toFixed(2) + 'px)' : '';
      segs[i].style.borderRadius = izq.toFixed(1) + 'px ' + der.toFixed(1) + 'px ' + der.toFixed(1) + 'px ' + izq.toFixed(1) + 'px';

      var n = necks[i];
      if (!n) continue;
      var g = gaps[i].x;
      var start = SPAN - g;
      var mid = start + g / 2;
      var waist = NECK_H * (1 - g / (SPAN * NECK_BREAK));
      if (g > 0.05 && waist > 0 && start > 0) {
        n.path.setAttribute('d', 'M' + start + ' 0 Q' + mid + ' ' + (NECK_H - waist) + ' ' + SPAN + ' 0 L' + SPAN + ' ' + NECK_H + ' Q' + mid + ' ' + waist + ' ' + start + ' ' + NECK_H + ' Z');
        n.s1.setAttribute('stop-color', (i - 1 === objetivo) ? C_ACT : C_BAR);
        n.s2.setAttribute('stop-color', (i === objetivo) ? C_ACT : C_BAR);
        n.svg.style.display = 'block';
      } else {
        n.svg.style.display = 'none';
      }
    }
  }

  var raf = null;
  function arranca() {
    if (raf || !activo) return;
    var t0 = performance.now();
    raf = requestAnimationFrame(function tick(t) {
      var dt = Math.min(0.033, Math.max(0.004, (t - t0) / 1000));
      t0 = t;
      var quieto = true;
      for (var k = 0; k < gaps.length; k++) {
        gaps[k].step(dt);
        if (!gaps[k].reposo()) quieto = false;
      }
      pinta();
      raf = quieto ? null : requestAnimationFrame(tick);
    });
  }

  function fija(i, instantaneo) {
    objetivo = i;
    for (var k = 1; k < segs.length; k++) {
      var abierta = (k === objetivo || k - 1 === objetivo);
      if (instantaneo || reduced) gaps[k].jump(abierta ? SPAN : 0);
      else gaps[k].set(abierta ? SPAN : 0);
    }
    segs.forEach(function (s, k) { s.classList.toggle('is-act', k === objetivo); });
    if (instantaneo || reduced) pinta();
    else arranca();
  }

  function apaga() {
    segs.forEach(function (s) {
      s.style.transform = '';
      s.style.borderRadius = '';
    });
    necks.forEach(function (n) { if (n) n.svg.style.display = 'none'; });
    gaps.forEach(function (m) { m.jump(0); });
  }

  segs.forEach(function (seg, i) {
    seg.addEventListener('mouseenter', function () { if (activo && i !== objetivo) fija(i); });
    seg.addEventListener('focusin', function () { if (activo && i !== objetivo) fija(i); });
  });
  nav.addEventListener('mouseleave', function () { if (activo && objetivo !== real) fija(real); });
  nav.addEventListener('focusout', function () {
    if (activo && objetivo !== real) setTimeout(function () {
      if (!nav.contains(document.activeElement)) fija(real);
    }, 10);
  });

  function revisa() {
    activo = mq.matches;
    if (!activo) { apaga(); return; }
    fija(real, true);
  }
  if (mq.addEventListener) mq.addEventListener('change', revisa);
  else if (mq.addListener) mq.addListener(revisa);
  window.addEventListener('resize', function () { if (!activo) apaga(); });

  if (activo) fija(real, true);
  else apaga();
})();
